<template>
    <div class="petType">
        <div class="petCon">
            <div class="petsType">
                <ul>
                    <li v-for="(pets,index) in petsType" :key="index" :class="pets.active=='true'?'selective':''" @click="petsNav(index,pets.active)"><span>{{pets.pets}}</span></li>
                </ul>
            </div>
            <div class="pets">
                <ul>
                    <li v-for="(petName,index) in pets" @click="selPets(petName.name)"><img :src="petName.picUrl"/>{{petName.name}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import Qs from "qs";
import {petType} from "../../apiNew/index.js"
export default {
    name:'addpetType',
    data() {
      return {
        lang:localStorage.getItem("locale"),
        activeName: 'first',
        petsType:[
            {pets:this.$t('addpet.cat'),active:'true',value:'CAT_TYPE'},
            {pets:this.$t('addpet.dog'),active:'false',value:'DOG_TYPE'}
        ],
        pramsPetType:'CAT_TYPE',
        pets:[],
        petsTo:{
            id:'',
            ispetsType: false
        }
      }
    },
    mounted(){
        this.getPetTypes()
        // console.log(this.lang)
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      petsNav(index,selective){
          this.petsType[index].active = 'true';
          for(let i=0;i<this.petsType.length;i++){
              if(i!=index){
                this.petsType[i].active = 'false';
              }
          }
          this.pramsPetType = this.petsType[index].value
          this.getPetTypes()
      },
      selPets(name){
          this.petsTo.id=name;
          this.$emit("petsN",this.petsTo)
//        console.log("向父组件传递宠物品种信息：",this.petsTo)
      },
      //获取宠物品种列表
      getPetTypes(){
           var params = Qs.stringify({
               lang:this.lang,
               petType: this.pramsPetType
           })
           petType(params)
           .then(res=>{
//             console.log("返回信息：",res)
               this.pets = res.data.data
           })
      }
    }
}
</script>
<style>
    body{
        position: relative;
    }
</style>
<style scoped>
    .petType{
        position: absolute;
        z-index: 999;
        width: 100%;
        height: 100%;
        top: 0;
        background: rgba(0, 0, 0, 0.23);
    }
    .petCon{
        width: 100%;
        height: 17rem;
        position: fixed;
        bottom: 0;
        background: #ffffff;
        padding-top: 0.5rem;
    }
    .petsType ul{
        width: 100%;
        display: inline-flex;
        justify-content: space-between;
        text-align: center;
    }
    .petsType ul li{
        width: 50%;
        list-style: none;
        height: 3.2rem;
        line-height: 3.2rem;
        font-size: 1rem;
    }
    .petsType ul li:nth-child(1)::after{
    	content: "";
	    display: inline-block;
	    width: 1px;
	    height: 40px;
	    background-color: #b1acac;
	    position: relative;
	    left: 75px;
	    top: 8px;
    }
    .selective span{
        padding-bottom: 0.3rem;
        border-bottom: 1px solid #7dc3f2;
        color: #7dc3f2;
    }
    .pets{
        width: 100%;
        border-top: 1px solid #e1e1e1;
    }
    .pets ul{
        width: 100%;
        height: 12.8rem;
        overflow-y: auto;
    }
    .pets ul li{
        width: 100%;
        border-bottom: 1px solid #e1e1e1;
        list-style: none;
        height: 3.2rem;
        line-height: 3.2rem;
        box-sizing: border-box;
        padding-left: 1.5rem;
        font-size: 0.8rem;

    }
    .pets ul li img{
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 1rem;
    }
</style>



// WEBPACK FOOTER //
// src/m_page/myAccount/addpetType.vue